import React, { useState, useContext, useEffect, useImperativeHandle, useRef } from "react";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import { Link, useLocation, useNavigate } from "react-router-dom";

import SuiBox from "components/SuiBox";
import SuiTypography from "components/SuiTypography";
import SuiSelect from "components/SuiSelect";
import SuiButton from "components/SuiButton";
import Chip from "@mui/material/Chip";
import Card from "@mui/material/Card";
import Avatar from "@mui/material/Avatar";

import Grid from "@mui/material/Grid";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import NumbersIcon from "@mui/icons-material/Numbers";

import toast from "react-hot-toast";

import CategoryContext from "context/category-context";

import api from "services/api";
import moment from "moment";

import { sizeChartOptions, seasonOptions } from "utils/data";
import { DatePicker, Divider } from "antd";

import colors from "assets/theme/base/colors";

const AddMiniFashionTagModal = React.forwardRef(
  (
    {
      visible,
      handleClose,
      handleOk,
      jobconf = {},
      setJobconf,
      handleRefresh = () => {},
      handleAfterOk = () => {},
      initSelected,
      refreshDelay = 0,
      tagSubOptions = [],
    },
    ref
  ) => {
    const [newjobconf, setNewjobconf] = useState(jobconf);

    const handleSave = () => {
      setJobconf(newjobconf);
      handleClose();
    };

    const handleTogglePromptArray = (item) => {
      setNewjobconf((prev) => {
        const myArray = prev?.prompt_array || [];
        let prompt_array = [...myArray];
        const findIndex = prompt_array.findIndex((x) => x == item.value);
        if (findIndex > -1) {
          prompt_array.splice(findIndex, 1);
        } else {
          prompt_array.push(item.value);
        }

        return { ...prev, prompt_array };
      });
    };

    return (
      <Dialog
        open={visible}
        onClose={(e, reason) => {
          if (reason != "backdropClick") {
            handleClose();
          }
        }}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        maxWidth="md"
        fullWidth={true}
      >
        <DialogTitle id="alert-dialog-title">
          Prompt Tags
          <IconButton
            aria-label="close"
            onClick={() => handleClose()}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <SuiBox sx={{ px: 3, py: 1 }}>
            <SuiTypography variant="h6" sx={{ mb: 1 }}>
              Select the tags you’d like to see in your design
            </SuiTypography>
            <SuiBox display="flex" flexWrap="wrap" gap={1}>
              {tagSubOptions.map((tag) => (
                <Chip
                  avatar={tag?.img ? <Avatar src={tag?.img} /> : null}
                  variant={
                    newjobconf?.prompt_array && newjobconf?.prompt_array.includes(tag.value)
                      ? "contained"
                      : "outlined"
                  }
                  label={tag.label}
                  size="medium"
                  color={
                    newjobconf?.prompt_array && newjobconf?.prompt_array.includes(tag.value)
                      ? "primary"
                      : "default"
                  }
                  sx={{ textTransform: "capitalize", px: 1 }}
                  onClick={(e) => handleTogglePromptArray(tag)}
                />
              ))}
            </SuiBox>
          </SuiBox>
        </DialogContent>
        <DialogActions>
          <SuiButton variant="gradient" size="medium" onClick={handleClose} color="light">
            Cancel
          </SuiButton>
          <SuiButton size="medium" variant="gradient" color="dark" onClick={handleSave}>
            Save
          </SuiButton>
        </DialogActions>
      </Dialog>
    );
  }
);

export default AddMiniFashionTagModal;
